/**
 * 获取字典名称
 */
export function getSysDictName(value, data) {
  const tmp = data.find(tmp => tmp.value == value)
  if (tmp) {
    return tmp.label
  }
  return ''
}
